import shortid from "shortid";
import { CabecalhoMainPrint, Grid } from "../../components";
import { formatPrice } from "../../utils";
import {
  ImpressaoRelatorioContainer,
  TableRelatorio,
  VisualizacaoRelatorioContainer,
} from "../../styles/shared";

const TablePrintResumidoComponent = ({
  id,
  filtrosAplicadosImpressao,
  relatoriosTotais,
  totais,
  tituloRelatorio,
  print,
  columns,
  itensPorPagina,
  customHeader,
  footerTotalizador,
}) => {
  const colunas = columns.filter((column) => !column.hide);
  const relatorioId = id ?? shortid.generate();
  const count = relatoriosTotais?.length
    ? Math.ceil(relatoriosTotais.length / itensPorPagina)
    : 0;
  return (
    <div id={`relatorio-${relatorioId}`}>
      {Array.from({ length: count }).map((_, pageIndex) => {
        const paginacaoInicial = filtrosAplicadosImpressao?.numeroPagina
          ? Number(filtrosAplicadosImpressao.numeroPagina)
          : 0;
        const itens = relatoriosTotais?.length
          ? relatoriosTotais.slice(
              pageIndex === 0
                ? pageIndex
                : itensPorPagina + (pageIndex - 1) * itensPorPagina,
              pageIndex === 0
                ? itensPorPagina
                : itensPorPagina + pageIndex * itensPorPagina
            )
          : [];
        const Container = !print
          ? VisualizacaoRelatorioContainer
          : ImpressaoRelatorioContainer;

        return (
          <Container
            id={`pagina-${pageIndex + 1}-relatorio-${relatorioId}`}
            key={pageIndex}
          >
            <CabecalhoMainPrint
              data={{
                tituloRelatorio,
                filtrosAplicadosImpressao,
                print,
                pagina: `${pageIndex + 1 + paginacaoInicial}/${
                  count + paginacaoInicial
                }`,
              }}
            />
            <Grid
              item
              id={`pagina-${pageIndex + 1}-tabela-${relatorioId}`}
              md={12}
              xs={12}
            >
              {customHeader}
              <TableRelatorio className="table table-borderless">
                <thead className="table-primary">
                  <tr>
                    {colunas.map((column, index) => (
                      <th
                        key={index}
                        style={{
                          textAlign: column?.align || "start",
                          width: column?.width,
                        }}
                      >
                        {column.header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {itens.map((item, index) => (
                    <tr key={index}>
                      {colunas.map((column, columnIndex) => (
                        <td key={columnIndex}>
                          <div
                            style={{
                              textAlign: column.align || "start",
                            }}
                          >
                            {column.render
                              ? column.render(item)
                              : item[column.field]}
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                  {pageIndex + 1 === count && totais && (
                    <tr className="table-primary">
                      {colunas.map((column, columnIndex) => (
                        <td key={columnIndex}>
                          <div
                            style={{
                              textAlign: column.align || "start",
                            }}
                          >
                            {totais[column.fieldTotal] >= 0 ? (
                              <b>
                                {column.renderTotal
                                  ? column.renderTotal(totais)
                                  : formatPrice(
                                      totais[column.fieldTotal],
                                      false
                                    )}
                              </b>
                            ) : null}
                          </div>
                        </td>
                      ))}
                    </tr>
                  )}
                </tbody>
              </TableRelatorio>
              {pageIndex + 1 === count && footerTotalizador}
            </Grid>
          </Container>
        );
      })}
    </div>
  );
};

export default TablePrintResumidoComponent;
